import React, { Component } from "react";
import firebase from 'firebase/app';
import {Switch, Route, Redirect} from 'react-router-dom';
import 'firebase/auth';
import DisplayNavbar from './Components/Navbar/NavbarView';
import Homepage from './Components/LandingPage/LandingPage';
import DisplayGuide from './Components/SustainabilityGuide/SustainabilityGuideView';
import DisplayDashboard from './Components/Dashboard/DashboardView';
import InputDataView from './Components/InputData/InputDataView.js';
import UploadWaterView from './Components/InputData/UploadWaterView.js';
import UploadGasView from './Components/InputData/UploadGasView.js';
import UploadElectricView from './Components/InputData/UploadElectricView.js';
import PastBillsWaterView from './Components/PastBills/PastBillsWaterView.js'
import PastBillsGasView from './Components/PastBills/PastBillsGasView.js'
import PastBillsElectricityView from './Components/PastBills/PastBillsElectricityView.js'
import BillDataModel from './Components/BillDataModel.js';
import GraphController from './Components/Dashboard/GraphController.js';
import GraphWaterController from './Components/Dashboard/GraphWaterController.js';
import GraphGasController from './Components/Dashboard/GraphGasController.js'



export default class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      signedIn: false, 
    }
  }


  componentDidMount() {
    this.authUnSubFunction = firebase.auth().onAuthStateChanged( (firebaseUser) => {
      if(firebaseUser) {
        this.setState( {user: firebaseUser, signedIn: true} );
      } else {
        this.setState( {user: null, signedIn: false} );
      }
    });    
  }

  componentWillUnmount(){
    this.authUnSubFunction();
  }

  handleSignOut = (props) => {
    //console.log("signing out...")
    this.setState({signedIn: false, user: null})
        firebase.auth().signOut()
        .then( () => {
            this.setState({signedIn: false})
        })
        .catch((err) => {
            this.setState({errorMessage: err.message});
        })
      
    }


  billDataCallback = (data) => {
    this.setState( {billData: data} )
    console.log(data);
  }


  signUpCallback = (signedIn, user) => {
    this.setState( {signedIn: signedIn, user: user} );
  }

  signInCallback = (signedIn, user) => {
    this.setState( {signedIn: signedIn, user: user} );
  }


  render() {
    let content;
    let billData;
    if (this.state.signedIn) {
      content = 
        <Route path='/home' component={ (routerProps) => (   
          <DisplayDashboard {...routerProps} user={this.state.user} billData={this.state.billData}/> 
        )}/>; 
        billData = <BillDataModel user={this.state.user} billDataCallback={this.billDataCallback}/> ;
    } else {
      content = 
        <Route path='/home' component={ (routerProps) => (
          <Homepage {...routerProps} signInCallback={this.signInCallback} signUpCallback={this.signUpCallback}/>
        )}/>
      billData = "";
    }

    return (
      <div>
        <DisplayNavbar handleSignOut={this.handleSignOut} loggedIn={this.state.signedIn}/>
        {billData}
        <Switch>
          {/* add correct home page */}
          {content}
          <Route path='/guide' component={ (routerProps) => (
            <DisplayGuide {...routerProps} />
          )}/>
          <Route path='/input' component={ (routerProps) => (
            <InputDataView {...routerProps} />
          )}/>
          <Route path='/pastbills/water' component={ (routerProps) => (
            <PastBillsWaterView {...routerProps} user={this.state.user} signedIn={this.state.signedIn}/>
          )}/>
          <Route path='/pastbills/gas' component={ (routerProps) => (
            <PastBillsGasView {...routerProps} user={this.state.user} signedIn={this.state.signedIn}/>
          )}/>
          <Route path='/pastbills/electricity' component={ (routerProps) => (
            <PastBillsElectricityView {...routerProps} user={this.state.user} signedIn={this.state.signedIn} />
          )}/>
          <Route path='/upload/water' component={ (routerProps) => (
            <UploadWaterView user={this.state.user} {...routerProps} />
          )}/>
          <Route path='/upload/gas' component={ (routerProps) => (
            <UploadGasView user={this.state.user} {...routerProps} />
          )}/>
          <Route path='/upload/electricity' component={ (routerProps) => (
            <UploadElectricView user={this.state.user} {...routerProps} />
          )}/>
          <Redirect to="/home" />
          
        </Switch>

        
      </div>
    );
  }
  
}

